import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12" }
const _hoisted_3 = {
  class: "col-12 mt-2",
  style: {"display":"flex","gap":"10px","height":"100%","overflow-x":"scroll","white-space":"nowrap"}
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", {
  class: "fas fa-file-pdf",
  style: {"color":"#ffa000","font-size":"24px"}
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("iframe", {
          id: 'iFrameDocumentos' + _ctx.componenteId,
          src: _ctx.rutaDocumento,
          width: "100%",
          style: {"height":"60vh"}
        }, "\r\n        ", 8, ["id", "src"])
      ]),
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(this.requisicion.documentos, (documento) => {
          return (_openBlock(), _createBlock("div", {
            class: "contenidoInfoDetalle archivoInfoDetalle d-block",
            key: documento.ruta
          }, [
            _createVNode("div", {
              class: "text-center",
              onClick: ($event: any) => (_ctx.MostrarArchivo(documento.documentoRequisicionPagoId, documento.mime)),
              style: {"cursor":"pointer","display":"inline-block"}
            }, [
              _hoisted_4,
              _createVNode("p", null, _toDisplayString(documento.ruta.substr(39).toLowerCase()), 1)
            ], 8, ["onClick"])
          ]))
        }), 128))
      ])
    ])
  ]))
}